import React, { useContext } from "react";
import "./LoginForm.scss";
import LogoTest from "../../images/logo-test.png";
import GoogleLogo from "../../images/google_logo.svg";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";

function LoginForm(props) {
  const { currentUser } = useContext(AuthContext);

  if (!!currentUser) {
    return <Navigate to="/" />;
  }

  const year = new Date().getFullYear();

  return (
    <div className="auth-section">
      <div className="auth-card">
        {/*<div className="logo"></div>*/}
        <div className="align-center">
          {" "}
          <img
            style={{ height: "40px", filter: " brightness(0) invert(1)" }}
            src={LogoTest}
            alt="logo"
          />
          <br />
          <br />
        </div>
        <div className="google-auth">
          <div className="google-auth-header">
            <span>Authorization with corporate account</span>
          </div>
          <div className="google-auth-link">
            <a
              style={{
                background:
                  "url(" + GoogleLogo + ") center no-repeat transparent",
              }}
              href={`/auth/google/redirect`}
            ></a>
          </div>
        </div>
        <div className="auth-card-footer">
          <div className="copyright-wrapper">
            <div className="copyright">
              <span>© {year} Energame, all rights reserved</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
